import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { CSSProperties, VFC } from "react";
import styled from "styled-components";
import { SpacingContent } from "types/graphql/generated";

interface Props {
  className?: string;
  content: SpacingContent;
}

const Spacing: VFC<Props> = withErrorBoundary(
  ({ content: { backgroundColor, heightMax, heightXl, heightLg, heightMd, heightSm, heightXs } }) => {
    return (
      <StyledTitle
        style={
          {
            "--height-max": `${heightMax}px`,
            "--height-xl": `${heightXl}px`,
            "--height-lg": `${heightLg}px`,
            "--height-md": `${heightMd}px`,
            "--height-sm": `${heightSm}px`,
            "--height-xs": `${heightXs}px`,
            "--background-color": `${backgroundColor || "#fff"}`,
          } as CSSProperties
        }
      >
        <div className="[ Spacing ]" />
      </StyledTitle>
    );
  },
  {}
);

const StyledTitle = styled.section`
  height: var(--height-max);
  background-color: var(--background-color);

  .Spacing {
    position: relative;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    height: var(--height-xl);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    height: var(--height-lg);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: var(--height-md);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    height: var(--height-sm);
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xs}px`}) {
    height: var(--height-xs);
  }
`;

gql`
  fragment SpacingContent on ComponentSpacingSpacing {
    backgroundColor
    heightMax
    heightXl
    heightLg
    heightMd
    heightSm
    heightXs
  }
`;

export { Spacing };
export type { Props as SpacingProps };
